<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Upload Signed Certificate</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <span class="fw-bold">
                Certificate:
            </span>
            {{ modalData.commonName }}
            <br><br>
            <input-field :inlineField="true" label="Certificate" type="object" :inputType="'file'" v-model="signedCertificate.certificate"
                :editable="true" />
            <input-field :inlineField="true" label="Trust Chain" type="object" :inputType="'file'" v-model="signedCertificate.trustChain"
                :editable="true" />
            <input-field :inlineField="true" label="Key Algorithm" type="radio" :options="keyAlgOptions" v-model="signedCertificate.keyAlgorithm"
                :editable="true" />
        </div>
        <div class="card-footer justify-content-end d-flex align-items-center gap-3">
            <button class="btn btn-primary" :disabled="creating" @click="onSubmit()">
                <div v-if="creating" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Submit
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import InputField from "../../components/InputField.vue";
export default {
    components: { InputField },
    data() {
        return {
            creating: false,
            signedCertificate: {},
            keyAlgOptions: [
                { label: "ECDSA", value: "ECDSA" },
                { label: "RSA", value: "RSA" },
            ]
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "AcknowledgeDenyWarnings",
    methods: {
        ...mapActions("aut", {
            createSignedCertificate: "createSignedCertificate",
        }),
        async onSubmit(){
            this.creating = true;
            let toastOptions;
            await this.createSignedCertificate({
                commonName: this.modalData.commonName,
                payload: this.signedCertificate
            }).then((response) => {
                toastOptions = {
                    message: "Signed certificate created successfully.",
                    type: "success"
                }
                // Call success callback if provided
                if (this.modalData.onSuccess && typeof this.modalData.onSuccess === 'function') {
                    this.modalData.onSuccess();
                }
                this.$store.dispatch('hideModal')
            }).catch(err => {
                console.log("error: ", err)
                let error = null
                if (err.response)
                    error = err.response.data.error;
                else error = err.message;
                toastOptions = {
                    message: error || "Something went wrong while creating signed certificate. Please contact support.",
                    type: "error"
                }
            })
            this.creating = false;
            this.$store.dispatch("addToast", toastOptions);
        }
    },
};
</script>

<style></style>